import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const PaymentCancelledPage = () => {
  return (
    <div data-testid="payment-cancelled-page" className="min-h-screen flex items-center justify-center bg-gray-50 py-20">
      <div className="max-w-md mx-auto px-6 text-center">
        <div className="h-24 w-24 rounded-full bg-gray-100 flex items-center justify-center mx-auto mb-8">
          <XCircle className="h-12 w-12 text-gray-400" />
        </div>
        <h1 className="text-3xl font-bold text-[#1E3A5F] mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
          Payment Cancelled
        </h1>
        <p className="text-gray-600 mb-8">
          Your payment was cancelled. No charges have been made to your account. You can try again whenever you're ready.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/school">
            <Button className="bg-[#1E3A5F] hover:bg-[#162c47] text-white" data-testid="back-to-courses-btn">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Back to Courses
            </Button>
          </Link>
          <Link to="/contact">
            <Button variant="outline" className="border-[#1E3A5F] text-[#1E3A5F]">
              Need Help?
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelledPage;
